export default __webpack_public_path__ + "a0027cbd270add23988ee2acf7bdcce0.jpg";